import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import Autosuggest from 'react-autosuggest';

import './autocomplete.field.scss';

class Autocomplete extends Component {
	state = {
		value: '',
		suggestions: [],
	};

	static defaultProps = {
		availableSuggestions: [],
	};

	componentDidUpdate(prevProps) {
		const {formikValue} = this.props;
		if (prevProps.formikValue && !formikValue) {
			this.setState({value: ''});
		}
	}

	componentWillUnmount() {
		clearTimeout(this.handler);
	}

	getSuggestions(value) {
		const {availableSuggestions} = this.props;
		const escapedValue = this.escapeRegexCharacters(value.trim());

		if (escapedValue === '') {
			return availableSuggestions;
		}

		return availableSuggestions.filter(suggestion => suggestion.toLowerCase().includes(escapedValue.toLowerCase()));
	}

	escapeRegexCharacters = str => (
		str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
	);

	getSuggestionValue = suggestion => (
		suggestion
	);

	renderSuggestion = suggestion => (
		<span>{suggestion}</span>
	);

	onChange = (event, {newValue}) => {
		const {setFieldValue, name} = this.props;

		setFieldValue(name, newValue);

		this.setState({
			value: newValue,
		});
	};

	onSuggestionsFetchRequested = async ({value}) => {
		clearTimeout(this.handler);
		this.handler = setTimeout(async () => {
			const {getSuggestions} = this.props;
			if (getSuggestions) {
				this.setState({
					suggestions: await getSuggestions(value),
				});
			} else {
				this.setState({
					suggestions: this.getSuggestions(value),
				});
			}
		}, 600);
	};

	onSuggestionsClearRequested = () => {
		this.setState({
			suggestions: [],
		});
	};

	render() {
		const {value, suggestions} = this.state;
		const {intl} = this.props;

		const inputProps = {
			placeholder: intl.formatMessage({id: 'formik.search'}),
			value,
			onChange: this.onChange,
		};

		return (
			<Autosuggest
				suggestions={suggestions}
				onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
				onSuggestionsClearRequested={this.onSuggestionsClearRequested}
				getSuggestionValue={this.getSuggestionValue}
				renderSuggestion={this.renderSuggestion}
				inputProps={inputProps}
			/>
		);
	}
}

export default injectIntl(Autocomplete);
